/**
 * append utility
 */

module.exports = append;

var appendTo = require('./appendTo');

/**
 * Append a node to an element
 *
 * @param  {SVGElement} element
 * @param  {SVGElement} node
 *
 * @return {SVGElement} the element
 */
function append(element, node) {
  appendTo(node, element);
  return element;
}


// WEBPACK FOOTER //
// ./~/tiny-svg/lib/append.js